import { COLUMN_CATEGORY, COLUMN_COMPANY, COLUMN_CONTACT_NUMBER, COLUMN_DEPARTMENT, COLUMN_DEVICE, COLUMN_DISPLAY_NAME, COLUMN_FIRST_NAME, COLUMN_LAST_NAME, COLUMN_SITE, COLUMN_STATUS, COLUMN_SUFFIX, COLUMN_TIME, COLUMN_UNIQUE_IDENTIFIER } from "../../constants/column-types";
import { FILTER_PROFILE, FILTER_SITES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";
import { ColumnFormattingClasses } from './constants/ColumnFormattingClasses';

const MusteredReportColumns: TableColumn[] = [
    {
        heading: "ID Number",
        accessor: "idNumber",
        isNumeric: false,
        id: 0,
        sortByName: "mstIdnumber",
        sortDirection: "asc",
        active: true,
        translationKey: "idNumber",
        isDefault: true,
        columnId: COLUMN_UNIQUE_IDENTIFIER
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        isNumeric: false,
        id: 1,
        sortByName: "mstDisplayname",
        sortDirection: "asc",
        active: true,
        translationKey: "displayName",
        isDefault: true,
        columnId: COLUMN_DISPLAY_NAME
    },
    {
        heading: "Department",
        accessor: "department",
        isNumeric: false,
        id: 2,
        sortByName: "department.deptName",
        sortDirection: "asc",
        active: true,
        translationKey: "department",
        isDefault: true,
        columnId: COLUMN_DEPARTMENT
    },
    {
        heading: "Status",
        accessor: "status",
        isNumeric: false,
        id: 3,
        sortByName: "status",
        sortDirection: "asc",
        active: true,
        translationKey: "status",
        isDefault: true,
        searchOnName: "status",
        lookupName: 'MusteringStatuses',
        valueFormatting: (value) => {
            const valueFormats = {
                "Absent": ColumnFormattingClasses.categoryGrey,
                "Mustered": ColumnFormattingClasses.categoryGreen,
                "Manually Mustered": ColumnFormattingClasses.categoryGreen,
                "Exited": ColumnFormattingClasses.categoryBlue,
                "Unaccounted": ColumnFormattingClasses.categoryRed,
            };
            return valueFormats[value];
        },
        columnId: COLUMN_STATUS
    },
    {
        heading: "Last Location",
        accessor: "deviceName",
        isNumeric: false,
        id: 4,
        sortByName: "deviceName",
        sortDirection: "asc",
        active: true,
        translationKey: "lastLocation",
        isDefault: true,
        columnId: COLUMN_DEVICE
    },
    {
        heading: "Last Seen Time",
        accessor: "lastSeenTime",
        isNumeric: false,
        id: 5,
        sortByName: "time",
        sortDirection: "asc",
        active: true,
        translationKey: "lastSeenTime",
        isDefault: true,
        columnId: COLUMN_TIME
    },
    {
        heading: "Company",
        accessor: "company",
        isNumeric: false,
        id: 6,
        sortByName: "company.compName",
        sortDirection: "asc",
        active: false,
        translationKey: "company",
        columnId: COLUMN_COMPANY
    },
    {
        heading: "First Name",
        accessor: "firstName",
        isNumeric: false,
        id: 7,
        sortByName: "mstFirstname",
        sortDirection: "asc",
        active: false,
        translationKey: "firstName",
        columnId: COLUMN_FIRST_NAME
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        isNumeric: false,
        id: 8,
        sortByName: "mstLastname",
        sortDirection: "asc",
        active: false,
        translationKey: "lastName",
        columnId: COLUMN_LAST_NAME
    },
    {
        heading: "Suffix",
        accessor: "suffix",
        isNumeric: false,
        id: 9,
        sortByName: "mstSuffix",
        sortDirection: "asc",
        active: false,
        translationKey: "suffix",
        columnId: COLUMN_SUFFIX
    },
    {
        heading: "Contact Number",
        accessor: "contactNumber",
        isNumeric: false,
        id: 10,
        sortByName: "mobileNumber",
        sortDirection: "asc",
        active: false,
        translationKey: "contactNumber",
        columnId: COLUMN_CONTACT_NUMBER
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 11,
        sortByName: "site.siteName",
        sortDirection: "asc",
        active: false,
        searchOnName: "site.id",
        lookupName: "site",
        translationKey: "site",
        columnId: COLUMN_SITE,
        filterId: FILTER_SITES,
        settingDataName: 'site',
        hideLookup: false,
    },
    {
        heading: "Category",
        accessor: "profile",
        isNumeric: false,
        id: 12,
        sortByName: "profile.trnName",
        sortDirection: "asc",
        active: false,
        translationKey: "category",
        searchOnName: "profile.id",
        lookupName: 'profile.id',
        columnId: COLUMN_CATEGORY,
        filterId: FILTER_PROFILE,        
        settingDataName: 'profile',       
    },
];

export default MusteredReportColumns;
